import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Tool } from "@app/tool/model/tool.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-replace-tool-modal',
    templateUrl: './replace-tool-modal.component.html',
    styleUrls: ['./replace-tool-modal.component.scss']
})
export class ReplaceToolModalComponent implements OnInit {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() message: string;
    @Input() replacementTools: Tool[];
    @Input() hasCancel = false;
    @Input() isLoading;

    @Output() confirmButtonPressed = new EventEmitter<any>();
    @Output() onRepairButtonPressed = new EventEmitter<any>();

    selectedTool: Tool;
    replacementTool: Tool;
    showValidations = false;
    replaceToolForm: UntypedFormGroup;

    constructor(private translateService: TranslateService) {
    }

    ngOnInit() {
        this.formInit();
    }


    open(tool = new Tool()) {
        this.formReset();
        this.formLoad(tool);
        this.modal.open();
    }

    onConfirm() {
        if (this.replaceToolForm.invalid) {
            this.showValidations = true;
            return;
        }

        this.confirmButtonPressed.emit(this.replacementTool);
        this.modal.close();
    }

    onRepair() {
        this.onRepairButtonPressed.emit(this.selectedTool);
        this.modal.close();
    }

    formInit() {
        this.replaceToolForm = new UntypedFormGroup({
            selectedTool: new UntypedFormControl({}, [<any>Validators.required]),
        });
    }

    formLoad(selectedTool: Tool) {
        this.selectedTool = selectedTool;
        this.replaceToolForm.setValue({
            selectedTool: ''
        });
    }

    formReset() {
        this.showValidations = false;
        this.selectedTool = new Tool();
        this.replaceToolForm.reset({selectedTool: 0});
    }

    onReplacementSelect(replacementTool: Tool) {
        this.replacementTool = replacementTool;
    }

    close() {
        this.modal.close();
    }

    shouldRenderReplacer() {
        return this.replacementTools && this.replacementTools.length > 0;
    }

    getTranslatedMessage(key: string) {
        if (key) {
            return this.translateService.instant(key);
        }
    }

}
